import React from 'react';
import { IconProps } from './types'; 

export const DefaultIcon: React.FC<any> = ({ svgHTML, size = 20, ...rest }) => {
  // Si no hay svgHTML, retornar null o un icono por defecto
  if (!svgHTML) {
    return null;
  }

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: svgHTML
          .replace('width="', `width="${size}"`)
          .replace('height="', `height="${size}"`)

      }}
    />
  );
};
